document.addEventListener('DOMContentLoaded', function() {
    init();
    headerMenuTorigger();
    headerHoverTorigger();
    headerDrawerCloseTorigger();
    customMvSliderTorigger();
    customImglinkSliderToggle();
    customFcSliderTorigger();
    moreBtnTorigger();
    customPsSliderTorigger();
    customRiSliderTorigger();
    scrollTargetTorigger();
    customFcCpageSliderTorigger();
    // customSmoothToggleTorigger();
    customMenuDrawerToggle();
    mokujiFnc();
    smoothScroll();
    filterRangeAjustToggle();
    productFollowingBtnToggle();
});

if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
       init();
        headerMenuTorigger();
        headerHoverTorigger();
        headerDrawerCloseTorigger();
        customMvSliderTorigger();
        customImglinkSliderToggle();
        customFcSliderTorigger();
        moreBtnTorigger();
        customPsSliderTorigger();
        customRiSliderTorigger();
        scrollTargetTorigger();
        customFcCpageSliderTorigger();
        // customSmoothToggleTorigger();
        customMenuDrawerToggle();
        mokujiFnc();
        smoothScroll();
        filterRangeAjustToggle();
        productFollowingBtnToggle();
    });
}

if (Shopify.designMode) {
    document.addEventListener('shopify:block:select', (e) => {
       init();
        headerMenuTorigger();
        headerDrawerCloseTorigger();
        customMvSliderTorigger();
        customImglinkSliderToggle();
        customFcSliderTorigger();
        moreBtnTorigger();
        customPsSliderTorigger();
        customRiSliderTorigger();
        scrollTargetTorigger();
        customFcCpageSliderTorigger();
        // customSmoothToggleTorigger();
        customMenuDrawerToggle();
        mokujiFnc();
        smoothScroll();
        filterRangeAjustToggle();
        productFollowingBtnToggle();
    });
}

/****************************************
      初期化JS
****************************************/
function init() {  
  const imglinkSection = document.querySelector('.c-imglink__section');
  const mvSection = document.querySelector('.c-mvisual__section');
  
  setTimeout(() => {
    imglinkSection?.classList.add('is-show');
  }, 400);

    mvSection?.classList.add('c-init-anim');
    setTimeout(() => {
        mvSection?.classList.remove('c-init-anim');
    }, 5000);
  
  const menuDetails = document.querySelectorAll('.c-header header-menu details');
  menuDetails.forEach(function(menuDetail) {
    menuDetail.addEventListener('click', function() {
        event.stopPropagation();
    });
  });
}


/****************************************
      ヘッダーのメニューホバーJS
****************************************/
function headerMenuTorigger() {
    if (document.querySelectorAll('[id*="Details-HeaderSubMenu"]') !== null) {
        headerMenuHover();
    }
};

function headerMenuHover() {
  const hasSubmenuItems = document.querySelectorAll('[id*="Details-HeaderSubMenu"]');
    hasSubmenuItems.forEach(function(hasSubmenuItem) {
      hasSubmenuItem.addEventListener('mouseover', function() {
          this.setAttribute('open', true);
      });
      hasSubmenuItem.addEventListener('mouseleave', function() {
          this.removeAttribute('open', false);
      });
  });
}

function headerHoverTorigger() {
    if (document.querySelectorAll('[id*="Details-HeaderMenu"]') !== null) {
        headerItemHover();
    }
};

function headerItemHover() {
  const headerMenuItems = document.querySelectorAll('[id*="Details-HeaderMenu"]');
    headerMenuItems.forEach((headerMenuItem) => {
      headerMenuItem.addEventListener('mouseover', function() {
          this.lastElementChild.style.pointerEvents = 'visible';
      });
      headerMenuItem.addEventListener('mouseleave', function() {
          this.lastElementChild.style.pointerEvents = 'none';
      });
    });
}


/****************************************
      ヘッダードロワーメニューの閉じるボタンJS
****************************************/
function headerDrawerCloseTorigger() {
    if (document.querySelector('.menu-drawer__navigation-container .icon-close') !== null) {
        headerDrawerClose();
    }
};

function headerDrawerClose() {
  const headerCloseIcon = document.querySelector('.menu-drawer__navigation-container .icon-close');
  const drawerContainer = document.querySelector('#Details-menu-drawer-container');
  const headerIconMenu = document.querySelector('.header__icon--menu');
  headerCloseIcon.addEventListener('click', function () {
    if(headerIconMenu.getAttribute('aria-expanded') === 'true') {
      headerIconMenu.setAttribute('aria-expanded', false);
      drawerContainer.classList.remove('menu-opening');
      document.body.classList.remove('overflow-hidden');
      document.body.classList.remove('overflow-hidden-tablet');
      setTimeout(() => {
          drawerContainer.removeAttribute('open');
      }, 550);
    }
  });
}


/****************************************
      画像リンクセクションのスライダーJS
****************************************/
function customImglinkSliderToggle() {
    if (document.querySelectorAll('.il-swiper__section').length > 0) {
        imglinkSlider();
    }
};

function imglinkSlider() {
  // console.log('test4');
    const ilSwiperSlides = document.querySelectorAll('.il-swiper__section');
    ilSwiperSlides.forEach(function(ilSwiperSlide) {
        let swiper, swiperBool;
        const breakPoint = 750;

        window.addEventListener("load",() => {
            if (breakPoint < window.innerWidth) {
                swiperBool = false;
            } else {
                createSwiper();
                swiperBool = true;
            }
        }, false);

        window.addEventListener("resize",() => {
            if (breakPoint < window.innerWidth && swiperBool) {
                swiper.destroy(false, true);
                swiperBool = false;
            } else if (breakPoint >= window.innerWidth && !swiperBool) {
                createSwiper();
                swiperBool = true;
            }
        }, false);
      
        function createSwiper() {
            const swiperSections = document.querySelectorAll('.il-swiper__section');
            swiperSections.forEach((swiperSection, i) => {
                const elms = document.querySelectorAll('.il-swiper__section .swiper');
                    swiper = new Swiper( elms[i], {
                    slidesPerView: 1.2,
                    spaceBetween: "4%",
                    loop: false,
                    speed: 1500,
                    autoplay: false,
                });
            });
        };
    })
}


/****************************************
    カスタム特集コレクションのもっと見るボタンのJS
****************************************/
function moreBtnTorigger() {
    if (document.querySelectorAll('.c-fcol__section .c-fcol__morebtn') !== null) {
        moreBtn();
    }
};

function moreBtn() {
      const fcolSections = document.querySelectorAll('.c-fcol__section');
    
      for (let s = 0; s < fcolSections.length; s++) {
          const btn = fcolSections[s].querySelector('.c-fcol__morebtn');
          const content = fcolSections[s].querySelector('.c-fcol__wrapper');
  
          const btnOpen = fcolSections[s].querySelector('.btn-open');
  
          let slideIndex;
          const splideList = fcolSections[s].querySelector('.splide__list');
          const firstSlideIndex = splideList.firstElementChild.dataset.slideIndex;
          const lastSlideIndex = splideList.lastElementChild.dataset.slideIndex;
        
          if(firstSlideIndex < lastSlideIndex) {
            slideIndex = lastSlideIndex; 
          } else if (firstSlideIndex > lastSlideIndex) {
            slideIndex = firstSlideIndex; 
          }
        
          if(slideIndex >= 4) {
              content.classList.add('c-fcol__gradation');
              btn.classList.add('is-show');
          } else {
              content.classList.remove('c-fcol__gradation');
              btn.classList.remove('is-show');
          }

          btn.addEventListener('click', function() {
              if(!content.classList.contains('open')){
                  content.style.maxHeight = content.scrollHeight + 'px';
                  content.classList.add('open');
                  btn.classList.add('is-close');
                  btn.setAttribute('aria-hidden', 'true');
              } else {
                  content.style.maxHeight = '115vw';
                  content.classList.remove('open');
                  btn.classList.remove('is-close');
                  btn.setAttribute('aria-hidden', 'false');
              }
          });
      }
}


/****************************************
    カスタム特集コレクションのスライダーJS
****************************************/
function customFcSliderTorigger() {
    if (document.querySelectorAll('.fcol-swiper__section') !== null) {
        customFcSlider();
    }
};

function customFcSlider() {
    const splideSections = document.querySelectorAll('.fcol-swiper__section');
    splideSections.forEach((swiperSection, i) => {
    const swiperWrapper = swiperSection.querySelector('.c-fcol__wrapper');
    const elms = document.querySelectorAll('.fcol-swiper__section .splide');

    let slideNum;
    slideNum = swiperWrapper.dataset.slideNum;

        new Splide( elms[i],{
            autoplay: false,
            type: "slide",
            arrows: false,
            interval: 2000,
            speed: 1500,
            perPage: slideNum,
            destroy: false,
            breakpoints: {
                750: {
                    destroy: true,
                },
            },
        }).mount();
    });
}


/****************************************
    コレクションページのカスタムスライダーJS
****************************************/
function customFcCpageSliderTorigger() {
    if (document.querySelectorAll('.fcol-swiper__cpage__section') !== null) {
        customFcCpageSlider();
    }
};

function customFcCpageSlider() {
    const splideSections = document.querySelectorAll('.fcol-swiper__cpage__section');
    splideSections.forEach((swiperSection, i) => {
    const swiperWrapper = swiperSection.querySelector('.c-fcol__wrapper');
    const elms = document.querySelectorAll('.fcol-swiper__cpage__section .splide');

    let slideNum;
    slideNum = swiperWrapper.dataset.slideNum;

        new Splide( elms[i],{
            autoplay: false,
            type: "slide",
            arrows: false,
            interval: 2000,
            speed: 1500,
            perPage: slideNum,
            destroy: false,
            breakpoints: {
                1100: {
                    destroy: true,
                },
            },
        }).mount();
    });
}


/****************************************
    メインビジュアルのスライダーJS
****************************************/
function customMvSliderTorigger() {
    if (document.querySelectorAll('.mv-splide__sp') !== null || document.querySelectorAll('.mv-splide__pc') !== null) {
        customMvSlider();
    }
};

function customMvSlider() {

  let mvSplideSp, mvSplidePc;
  const mvSection = document.querySelector('.c-mvisual__section');

  if (document.querySelectorAll('.mv-splide__sp') !== null) {
    const splideSpSections = document.querySelectorAll('.mv-splide__sp');
    splideSpSections.forEach((splideSpSection, i) => {

      const elmsSp = splideSpSection.querySelectorAll('.splide');
        mvSplideSp = new Splide( elmsSp[i],{
          mediaQuery: 'min',
          autoplay: true,
          type: "fade",
          pagination: true,
          interval: 5000,
          speed: 0,
          rewind: true,
          pauseOnHover: false,
          pauseOnFocus: false,
          arrows: false,
          updateOnMove: true,
          breakpoints: {
              750: {
                destroy: true
              },
            },
        });
        mvSplideSp.mount();

    });
  }

  if (document.querySelectorAll('.mv-splide__pc') !== null) {
    const splidePcSections = document.querySelectorAll('.mv-splide__pc');
    splidePcSections.forEach((splidePcSection, i) => {

      const elmsPc = splidePcSection.querySelectorAll('.splide');
      mvSplidePc = new Splide( elmsPc[i],{
        mediaQuery: 'max',
        autoplay: true,
        type: "loop",
        pagination: true,
        interval: 5000,
        speed: 0,
        rewind: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        arrows: true,
        drag: false,
        updateOnMove: true,
        focus: "center",
        perPage: 3,
        breakpoints: {
              749: {
                  destroy: true
              },
          },
      });
      mvSplidePc.mount();

    });
  }

  let bodyOverlay;
  const mvBtns = document.querySelectorAll('.c-mvisual__link');
  const headerIcons = document.querySelectorAll('.header__icon');
  const headerSearch = document.querySelector('.header__search');
  const modalOverlay = document.querySelector('.modal-overlay');
  const mvTextAnim = document.querySelector('.c-mvisual__section .is-visible .c-mvisual__title');
  const mvBtnAnim = document.querySelector('.c-mvisual__section .is-visible .c-mvisual__linkbox');
  const splideAutoplayPc = mvSplidePc?.Components.Autoplay;
  const splideAutoplaySp = mvSplideSp?.Components.Autoplay;

  if(mvBtns) {
    mvBtns.forEach((mvBtn) => {
      const mvBtnBox = mvBtn.parentNode;
      const mvText = mvBtn.parentNode.previousElementSibling;
      const mvImgBox = mvBtn.parentNode.parentNode.nextElementSibling;
      mvBtn.addEventListener('mouseover', function() {
        splideAutoplayPc.pause();
        mvText.classList.add('is-stop');
        mvBtnBox.classList.add('is-stop');
      });
      mvBtn.addEventListener('mouseleave', function() {
        splideAutoplayPc.play();
        mvText.classList.remove('is-stop');
        mvBtnBox.classList.remove('is-stop');
      });
    });
  }

  headerIcons.forEach((headerIcon) => {
    headerIcon.addEventListener('click', function() {
        if(headerIcon.getAttribute('aria-expanded') === 'true') {
          splideAutoplaySp.pause();
          splideAutoplayPc.pause();
          mvTextAnim.classList.add('is-stop');
          mvBtnAnim.classList.add('is-stop');
        } else {
          splideAutoplaySp.play();
          splideAutoplayPc.play();
          mvTextAnim.classList.remove('is-stop');
          mvBtnAnim.classList.remove('is-stop');
        }
    });
  });
  
  headerSearch.addEventListener('click', function() {
    const headerSearchDetails = headerSearch.querySelector('details');
    const bodyOverlay = document.querySelector('.overflow-hidden');
    if(headerSearchDetails.hasAttribute('open')) {
      splideAutoplaySp.pause();
      splideAutoplayPc.pause();
      mvTextAnim.classList.add('is-stop');
      mvBtnAnim.classList.add('is-stop');
    } else {
      splideAutoplaySp.play();
      splideAutoplayPc.play();
      mvTextAnim.classList.remove('is-stop');
      mvBtnAnim.classList.remove('is-stop');
    }

    bodyOverlay?.addEventListener('click', function() {
      if(!headerSearchDetails?.hasAttribute('open')) {
        headerIcons.forEach((headerIcon) => {
          if(headerIcon.getAttribute('aria-expanded') === 'false') {
            splideAutoplaySp.play();
            splideAutoplayPc.play();
            mvTextAnim.classList.remove('is-stop');
            mvBtnAnim.classList.remove('is-stop');
          }
        });
      }
    });
  });
}


/****************************************
    商品ページのヒーロー画像のスライダーJS
****************************************/
function customPsSliderTorigger() {
    if (document.querySelectorAll('.ps-splide__section') !== null) {
        customPsSlider();
    }
};

function customPsSlider() {
    productSlideCheck();
  
    const splideSections = document.querySelectorAll('.ps-splide__section');

    splideSections.forEach((swiperSection, i) => {
        const elms = document.querySelectorAll('.ps-splide__section .splide');

        const psSplide = new Splide('.ps-splide__section .splide', {
            pagination: true,
            arrow: false,
            type: "fade",
            rewind: true,
            interval: 2000,
            speed: 1500,
            breakpoints: {
                749: {
                    pagination: true,
                },
            },
        });

        const thumbnails = swiperSection.getElementsByClassName('c-proslide__thumb');
        let current;

        for (let i = 0; i < thumbnails.length; i++) {
            initThumbnail(thumbnails[i], i);
        }

        function initThumbnail(thumbnail, index) {
            thumbnail.addEventListener('click', function() {
                psSplide.go(index);
            });
        }

        psSplide.on('mounted move', function() {
        const thumbnail = thumbnails[ psSplide.index ];

        if (thumbnail) {
            if (current) {
                current.classList.remove('is-active');
            }

            thumbnail.classList.add('is-active');
            current = thumbnail;
            }
        });
      
        psSplide.mount();
    });
}

function productSlideCheck() {
    const psSection = document.querySelector('.c-proslide__section');

    const splideList = psSection?.querySelector('.splide__list');
    const slideIndex = splideList?.lastElementChild.dataset.slideIndex;

    if(slideIndex && slideIndex === '1') {
        psSection?.classList.add('no-slide');
    } else {
        psSection?.classList.remove('no-slide');
    }
}


/****************************************
    おすすめ情報セクションのスライダーJS
****************************************/
function customRiSliderTorigger() {
    if (document.querySelectorAll('.ri-splide__section') !== null) {
        customRiSlider();
    }
};

function customRiSlider() {
    const swiperSections = document.querySelectorAll('.ri-splide__section');
    swiperSections.forEach((swiperSection, i) => {
    const elms = document.querySelectorAll('.ri-splide__section .splide');

        new Splide( elms[i],{
            mediaQuery: 'min',
            autoplay: false,
            type: "loop",
            arrows: false,
            pagination: false,
            fixedWidth: '76vw',
            interval: 2000,
            speed: 1500,
            updateOnMove: true,
            breakpoints: {
                750: {
                    perMove: 1,
                    arrows: true,
                    pagination: true,
                    gap: 40,
                    rewind: true,
                    focus: "center",
                    perPage: 3,
                },
            },
        }).mount();
    });
}


/****************************************
      スクロールフェイドアウトのJS
****************************************/
function scrollTargetTorigger() {
    if (document.querySelectorAll('.scroll-target-pc') !== null || document.querySelectorAll('.scroll-target-mb') !== null) {
        scrollTarget();
    }
};

function scrollTarget() {
    const toriggerEl = document.querySelector('.c-facets-vertical-container');
    let target_posi;

    if (toriggerEl !== null) {
    window.addEventListener('scroll', function () {

        function checkBreakPoint() {
          let w = window.innerWidth;
          if (w <= 750) {
              // スマホ向け
              target_posi = document.querySelector('.scroll-target-mb').getBoundingClientRect().top;
          } else {
              // PC向け
              target_posi = document.querySelector('.scroll-target-pc').getBoundingClientRect().top;
          }
        }
        window.addEventListener("resize", function () {
            checkBreakPoint();
        });
        checkBreakPoint();

        if (target_posi <= window.innerHeight) {
            toriggerEl.style.display = 'none';
            document.querySelector(".c-smooth-toggle").classList.remove('is-open');
            document.querySelector('.c-smooth-toggle__content').style.display = 'none';
        } else {
             toriggerEl.style.display = 'block';
        }
    });
  }
}


/****************************************
    スムーズトグルのJS
****************************************/
// function customSmoothToggleTorigger() {
//     if (document.querySelectorAll('.c-smooth-toggle__content') !== null) {
//         customSmoothToggle();
//     }
// };

// function customSmoothToggle() {
//     const el = document.querySelector('.c-smooth-toggle__content');
//     const slideToggleBtn = document.querySelector(".c-smooth-toggle");

//     slideToggleBtn?.addEventListener("click", () => {
//         slideToggle(el, 300);
//     });

//     const slideToggle = (el, duration = 300) => {
//         if (window.getComputedStyle(el).display === "none") {
//             return slideDown(el, duration);
//         } else {
//             return slideUp(el, duration);
//         }
//     };

//     // slideUp
//     const slideUp = (el, duration = 300) => {
//         el.style.height = el.offsetHeight + "px";
//         el.offsetHeight;
//         el.style.transitionProperty = "height, margin, padding";
//         el.style.transitionDuration = duration + "ms";
//         el.style.transitionTimingFunction = "ease";
//         el.style.overflow = "hidden";
//         el.style.height = 0;
//         el.style.paddingTop = 0;
//         el.style.paddingBottom = 0;
//         el.style.marginTop = 0;
//         el.style.marginBottom = 0;
//         setTimeout(() => {
//             el.style.display = "none";
//             el.style.removeProperty("height");
//             el.style.removeProperty("padding-top");
//             el.style.removeProperty("padding-bottom");
//             el.style.removeProperty("margin-top");
//             el.style.removeProperty("margin-bottom");
//             el.style.removeProperty("overflow");
//             el.style.removeProperty("transition-duration");
//             el.style.removeProperty("transition-property");
//             el.style.removeProperty("transition-timing-function");
//         }, duration);

//         slideToggleBtn.classList.remove('is-open');
//     };

//     // slideDown
//     const slideDown = (el, duration = 300) => {
//         el.style.removeProperty("display");
//         let display = window.getComputedStyle(el).display;
//         if (display === "none") {
//             display = "flex";
//         }
//         el.style.display = display;
//         let height = el.offsetHeight;
//         el.style.height = 0;
//         el.style.paddingTop = 0;
//         el.style.paddingBottom = 0;
//         el.style.marginTop = 0;
//         el.style.marginBottom = 0;
//         el.offsetHeight;
//         el.style.transitionProperty = "height, margin, padding";
//         el.style.transitionDuration = duration + "ms";
//         el.style.transitionTimingFunction = "ease";
//         el.style.overflow = "hidden";
//         el.style.height = height + "px";
//         el.style.removeProperty("padding-top");
//         el.style.removeProperty("padding-bottom");
//         el.style.removeProperty("margin-top");
//         el.style.removeProperty("margin-bottom");
//         setTimeout(() => {
//             el.style.removeProperty("height");
//             el.style.removeProperty("overflow");
//             el.style.removeProperty("transition-duration");
//             el.style.removeProperty("transition-property");
//             el.style.removeProperty("transition-timing-function");
//         }, duration);

//         slideToggleBtn.classList.add('is-open');
//     };
// }

function customMenuDrawerToggle() {
    if (document.querySelectorAll('.c-menudrawer-toggle') !== null) {
        customMenuDrawer();
    }
};
function customMenuDrawer() {
    const slideToggleBtns = document.querySelectorAll('.c-menudrawer-toggle');

   slideToggleBtns.forEach(function(slideToggleBtn) {
      const el = slideToggleBtn.nextElementSibling;
  
      slideToggleBtn?.addEventListener("click", () => {
          slideToggle(el, 600);
      });
  
      const slideToggle = (el, duration = 600) => {
          if (window.getComputedStyle(el).display === "none") {
              return slideDown(el, duration);
          } else {
              return slideUp(el, duration);
          }
      };
  
      // slideUp
      const slideUp = (el, duration = 600) => {
          el.style.height = el.offsetHeight + "px";
          el.offsetHeight;
          el.style.transitionProperty = "height, margin, padding";
          el.style.transitionDuration = duration + "ms";
          el.style.transitionTimingFunction = "ease";
          el.style.overflow = "hidden";
          el.style.height = 0;
          el.style.paddingTop = 0;
          el.style.paddingBottom = 0;
          el.style.marginTop = 0;
          el.style.marginBottom = 0;
          setTimeout(() => {
              el.style.display = "none";
              el.style.removeProperty("height");
              el.style.removeProperty("padding-top");
              el.style.removeProperty("padding-bottom");
              el.style.removeProperty("margin-top");
              el.style.removeProperty("margin-bottom");
              el.style.removeProperty("overflow");
              el.style.removeProperty("transition-duration");
              el.style.removeProperty("transition-property");
              el.style.removeProperty("transition-timing-function");
          }, duration);
  
          slideToggleBtn.classList.remove('is-open');
      };
  
      // slideDown
      const slideDown = (el, duration = 600) => {
          el.style.removeProperty("display");
          let display = window.getComputedStyle(el).display;
          if (display === "none") {
              display = "block";
          }
          el.style.display = display;
          let height = el.offsetHeight;
          el.style.height = 0;
          el.style.paddingTop = 0;
          el.style.paddingBottom = 0;
          el.style.marginTop = 0;
          el.style.marginBottom = 0;
          el.offsetHeight;
          el.style.transitionProperty = "height, margin, padding";
          el.style.transitionDuration = duration + "ms";
          el.style.transitionTimingFunction = "ease";
          el.style.overflow = "hidden";
          el.style.height = height + "px";
          el.style.removeProperty("padding-top");
          el.style.removeProperty("padding-bottom");
          el.style.removeProperty("margin-top");
          el.style.removeProperty("margin-bottom");
          setTimeout(() => {
              el.style.removeProperty("height");
              el.style.removeProperty("overflow");
              el.style.removeProperty("transition-duration");
              el.style.removeProperty("transition-property");
              el.style.removeProperty("transition-timing-function");
          }, duration);
  
          slideToggleBtn.classList.add('is-open');
      };
   });
}


/****************************************
    お役立ちコラム記事の目次JS
****************************************/
function mokujiFncToggle() {
    if (document.querySelector('#toc') !== null) {
        mokujiFnc();
    }
};

function mokujiFnc() {
    const toc = document.querySelector('#toc');
    const selector = document.querySelector('.c-article__column__content'); //記事コンテンツ場所

    if (selector !== null) {

        // 目次コンテンツの生成
        const ul = document.createElement('ul');
        ul.className = 'toc-container';
        toc.appendChild(ul);

        const articleTocs = selector.querySelectorAll('h2, h3, h4'); // 対象見出しタグ
        const order = [];
        const stack = [{level: 1, element: ul}];

        articleTocs.forEach((articleToc) => {
            const level = parseInt(articleToc.tagName.substring(1))
            order.push(level);
        });

        articleTocs.forEach((articleToc, i) => {
            const level = parseInt(articleToc.tagName.substring(1));
            const next = order[i + 1];
            const ul = document.createElement('ul');
            const li = document.createElement('li');
            const p = document.createElement('p');
            const a = document.createElement('a');
            const id = 'toc-' + (i + 1);
            const tagName = articleToc.tagName; //タグを取得
        
            // 目次要素の生成
            p.textContent = articleToc.textContent;
            a.href = `#${id}`;
            li.appendChild(a);
            a.appendChild(p);
            if (level < next) {
              li.appendChild(ul);
            }
        
            // リンク先の生成
            articleToc.id = id;
        
            // 階層構造の生成
            let parent;
            do {
              parent = stack.pop();
            } while (parent.level >= level);
            parent.element.appendChild(li);
            stack.push(parent);
            stack.push({level: level, element: ul});
        });
    }
  
    smoothScroll();
}


/****************************************
    スムーススクロールJS
****************************************/
function smoothScroll() {
  const headerHeight = document.querySelector('.c-header').offsetHeight;
  const announcementElement = document.querySelector('.c-announcement-bar');
  const announcementHeight = announcementElement ? announcementElement.offsetHeight : 0;
  const allHeaderHeight = headerHeight + announcementHeight + 30;
  
  const scorrllLinks = document.querySelectorAll('a[href^="#"]');
    scorrllLinks.forEach((scorrllLink) => {
        scorrllLink.addEventListener("click", (e) => {
            e.preventDefault();
            const hrefLink = scorrllLink.getAttribute("href");
            const targetContent = document.getElementById(hrefLink.replace("#", ""));
            const rectTop = targetContent?.getBoundingClientRect().top;
            const positionY = window.pageYOffset - allHeaderHeight;
            const target = rectTop + positionY;
            window.scrollTo({
            top: target,
            behavior: "smooth",
            });
        });
    });
}



/****************************************
    コレクションページ フィルター条件変更時の発火JS
****************************************/
const collectionHref = location.href;
const collectionObserver = new MutationObserver(function(mutations) {
  if(collectionHref !== location.href) {
    // customSmoothToggleTorigger();
    filterRangeAjustToggle();
  }
});
collectionObserver.observe(document, { childList: true, subtree: true });

const facetsRemoveBtn = document.querySelector('.active-facets__button-remove');
facetsRemoveBtn?.addEventListener('click', function() {
    // customSmoothToggleTorigger();
    filterRangeAjustToggle();
});


/****************************************
    コレクションフィルターのレンジ調整JS
****************************************/
function filterRangeAjustToggle() {
    if (document.querySelector('price-range') !== null) {
        filterRangeAjust();
    }
};

function filterRangeAjust() {
  const priceRange = document.querySelector('price-range');
  const priceRangeInput = priceRange.querySelectorAll('input');
  
  const customRangeMin = document.querySelector('.c-range-min');
  const customRangeMax = document.querySelector('.c-range-max');
  
  customRangeMin.addEventListener('change', function() {
      const customMinValue = Number(this.value);
      priceRangeInput[0].value = customMinValue;
  })
  customRangeMax.addEventListener('change', function() {
      const customMaxValue = Number(this.value);
      priceRangeInput[1].value = customMaxValue;
  })
  customRangeMin.addEventListener('input', function() {
      const customMinValue = Number(this.value);
      priceRangeInput[0].value = customMinValue;
  })
  customRangeMax.addEventListener('input', function() {
      const customMaxValue = Number(this.value);
      priceRangeInput[1].value = customMaxValue;
  })
  
  priceRangeInput[0].addEventListener('input', function() {
      const minValue = Number(this.value);
      customRangeMin.value = minValue;
  })
  priceRangeInput[1].addEventListener('input', function() {
      const maxValue = Number(this.value);
      customRangeMax.value = maxValue;
  })
}


/****************************************
    商品ページの追従ボタンJS
****************************************/
function productFollowingBtnToggle() {
    if (document.querySelector('.c-mainproduct__folbtn') !== null) {
        productFollowingBtn();
    }
};

function productFollowingBtn() {
  const productFolBtn = document.querySelector('.c-mainproduct__folbtn');

    productFolBtn.addEventListener('click', function() {
       const element = document.querySelector('.product__info-wrapper');
        element?.scrollIntoView({  
        behavior: 'smooth',
        block: "end",
      });
    });
  
    const toriggerEl = document.querySelector('.c-mainproduct .product-form__submit');
    const fadeoutEl = document.querySelector('.c-mainproduct__details__box').lastElementChild;
    let target_posi, fadeout_posi;
  
      if (toriggerEl !== null) {
      window.addEventListener('scroll', function () {
  
          function checkBreakPoint() {
            let w = window.innerWidth;
            if (w <= 750) {
                target_posi = toriggerEl?.getBoundingClientRect().top;
                fadeout_posi = fadeoutEl?.getBoundingClientRect().top;
            }
          }
          window.addEventListener("resize", function () {
              checkBreakPoint();
          });
          checkBreakPoint();
  
          if (target_posi <= 0 && fadeout_posi >= 0) {
              productFolBtn.classList.add('is-show');
          } else {
               productFolBtn.classList.remove('is-show');
          }
      });
    }
}


/****************************************
    スムーストグルボタン
****************************************/
$(function(){
	$('.facets__form-vertical .c-smooth-toggle').click(function(e){
	$(this).siblings('.c-smooth-toggle__content').slideToggle();
	});
});
$(function(){
	$('.c-mainproduct__details .c-smooth-toggle').click(function(e){
	$(this).siblings('.c-smooth-toggle__content').slideToggle();
	});
});


/****************************************
    商品一覧の会社紹介アコーディオン(追記)
****************************************/
$(function () {
  $("#js-accordion-title").on("click", function () {
    $(this).next().slideToggle(600);
    $("#js-accordion-title .arrow").toggleClass("open", 600);
  });
});

/****************************************
    マイページ住所変更画面のモーダル(追記)
****************************************/
$(function() {
  var screenHeight = $(window).height();
  var headerHeight = $('.header').height(); 
  var maxContentHeight = screenHeight - headerHeight * 2;
  $('.customer-edit-address').css({
    'max-height': 'calc(100vh - ' + (headerHeight * 2) + 'px)', 
    'top': 'calc(45% + ' + headerHeight + 'px)'
  });
});


/****************************************
  商品一覧の絞り込み項目の非表示(追記)
****************************************/
// document.addEventListener('DOMContentLoaded', function() {
//   $('option[value=title-ascending], option[value=title-descending], option[value=created-ascending], option[value=created-descending]').wrap('<span class="selector-hide">');
// });


/****************************************
  SPハンバーガーメニューのリンクをクリックで閉じる(追記)
****************************************/
$(document).ready(function() {
    $(".menu-drawer__inner-submenu").click(function() {
        $("#Details-menu-drawer-container").removeClass("menu-opening").removeAttr("open");
        $("summary.header__icon--menu").attr("aria-expanded", "false");
    });
});

/****************************************
  ページ内リンクをリロードで移動する(追記)
****************************************/
// jQuery('a[href^="#"]').on('click',function() { return false; });
// jQuery('a[href^="#"]').on('click',function() {
//   var href= jQuery(this).attr("href");
//   window.location.href = ".//"+href;
// });



